'use strict';
(() => {
  const filmDialog=document.getElementById('film-dialog');
  const film=document.getElementById('film-video');
  let opener=null;
  document.querySelectorAll('[data-film]').forEach(button=>button.addEventListener('click',()=>{
    opener=button;filmDialog.showModal();document.body.classList.add('modal-open');
    if(!film.getAttribute('src'))film.src=film.dataset.videoSrc;
    film.currentTime=0;film.play().catch(()=>{});
  }));
  document.querySelector('.film-close').addEventListener('click',()=>filmDialog.close());
  filmDialog.addEventListener('click',event=>{if(event.target===filmDialog){const r=filmDialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)filmDialog.close();}});
  filmDialog.addEventListener('close',()=>{film.pause();document.body.classList.remove('modal-open');if(opener)opener.focus({preventScroll:true});});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)film.pause();});
  const explorer=document.querySelector('.science-explorer');
  document.querySelector('.light-tabs').addEventListener('tabchange',event=>{
    const selected=document.getElementById(event.detail.id);
    explorer.dataset.light=selected.dataset.colour;
    document.getElementById('light-number').textContent=selected.querySelector('b').textContent.replace(' nm','');
  });
  document.querySelectorAll('[data-goal-target]').forEach(link=>link.addEventListener('click',()=>{const tab=document.getElementById('goal-'+link.dataset.goalTarget);if(tab){tab.click();tab.focus({preventScroll:true});}}));
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const eliteVideo=document.getElementById('elite-video');
  const eliteToggle=document.querySelector('.elite-video-toggle');
  if(eliteVideo&&eliteToggle){
    let inView=false;
    let userPaused=false;
    let userStarted=false;
    const updateEliteButton=()=>{
      const playing=!eliteVideo.paused&&!eliteVideo.ended;
      const label=playing?eliteToggle.dataset.pauseLabel:eliteToggle.dataset.playLabel;
      eliteToggle.setAttribute('aria-label',label);
      eliteToggle.querySelector('[data-video-label]').textContent=label;
      eliteToggle.querySelector('[data-video-icon]').textContent=playing?'Ⅱ':'▷';
    };
    const startElite=()=>{
      if(!inView||document.hidden||userPaused||(reduced.matches&&!userStarted))return;
      if(!eliteVideo.getAttribute('src')){
        eliteVideo.src=eliteVideo.dataset.videoSrc;
        eliteVideo.load();
      }
      eliteVideo.muted=true;
      eliteVideo.play().catch(updateEliteButton);
    };
    eliteToggle.hidden=false;
    eliteToggle.addEventListener('click',()=>{
      if(eliteVideo.paused){userPaused=false;userStarted=true;startElite();}
      else{userPaused=true;eliteVideo.pause();}
    });
    eliteVideo.addEventListener('play',updateEliteButton);
    eliteVideo.addEventListener('pause',updateEliteButton);
    if('IntersectionObserver' in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        inView=entry.isIntersecting;
        if(inView)startElite();else eliteVideo.pause();
      }),{threshold:.2});
      observer.observe(eliteVideo);
    }else{inView=true;startElite();}
    document.addEventListener('visibilitychange',()=>{if(document.hidden)eliteVideo.pause();else startElite();});
    reduced.addEventListener('change',()=>{if(reduced.matches){userStarted=false;eliteVideo.pause();}else startElite();});
  }
  const motionButton=document.querySelector('.motion-toggle');
  const campaignScene=document.querySelector('.campaign-scene');
  if(motionButton&&campaignScene){
    motionButton.addEventListener('click',()=>{
      const paused=campaignScene.classList.toggle('motion-paused');
      motionButton.setAttribute('aria-pressed',String(paused));
      motionButton.setAttribute('aria-label',paused?motionButton.dataset.playLabel:motionButton.dataset.pauseLabel);
      motionButton.querySelector('span').textContent=paused?'▷':'Ⅱ';
    });
  }
  if('IntersectionObserver' in window&&!reduced.matches){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}}),{threshold:.08});
    document.querySelectorAll('.section-heading,.science-head,.professional-copy,.experience-copy').forEach(el=>{el.classList.add('reveal');observer.observe(el);});
    document.body.classList.add('editorial-ready');
  }
})();
